import script from "./Discover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Discover.vue?vue&type=script&setup=true&lang=ts"

import "./Discover.vue?vue&type=style&index=0&id=93e112fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93e112fe"]])

export default __exports__